const domaninVar = {
    company: "合肥市瑶海区合挈日用百货店",
    beian:'皖ICP备2023013365号-3',
    domain: '8lb.cn'
}

export default domaninVar


// WEBPACK FOOTER //
// ./src/containers/web/var.js